export const HARD_SETUP_ITEMS = [
  'organization',
  'granja',
  'admin_user',
  'galpao',
  'lote',
] as const

export type HardSetupItem = (typeof HARD_SETUP_ITEMS)[number]

export const WIZARD_STEP_ORDER: HardSetupItem[] = [
  'organization',
  'granja',
  'admin_user',
  'galpao',
  'lote',
]

export const STAGE2_ITEMS = [
  'colaboradores',
  'fornecedores',
  'estoque_itens',
  'clientes',
] as const

export interface SetupStatusCounts {
  organizations: number
  granjas: number
  galpoes: number
  lotes: number
  colaboradores: number
  fornecedores: number
  estoque_itens: number
  clientes: number
}

export interface SetupStatus {
  granja_id: string | null
  role: string
  role_org: string | null
  role_granja: string | null
  can_setup: boolean
  blocking: boolean
  missing: string[]
  stage: number | string
  counts: SetupStatusCounts
}

export const DEFAULT_SETUP_STATUS: SetupStatus = {
  granja_id: null,
  role: 'user',
  role_org: null,
  role_granja: null,
  can_setup: false,
  blocking: false,
  missing: [],
  stage: 'complete',
  counts: {
    organizations: 0,
    granjas: 0,
    galpoes: 0,
    lotes: 0,
    colaboradores: 0,
    fornecedores: 0,
    estoque_itens: 0,
    clientes: 0,
  },
}

export function isHardIncomplete(missing: string[]): boolean {
  return missing.some((item) => HARD_SETUP_ITEMS.includes(item as HardSetupItem))
}

export function getWizardStep(missing: string[]): HardSetupItem | null {
  for (const step of WIZARD_STEP_ORDER) {
    if (missing.includes(step)) return step
  }
  return null
}

export function getStage2Progress(counts: SetupStatusCounts): { done: number; total: number } {
  const checks = [
    counts.colaboradores > 0,
    counts.fornecedores > 0,
    counts.estoque_itens > 0,
    counts.clientes > 0,
  ]
  return { done: checks.filter(Boolean).length, total: checks.length }
}

export function setupStatusQueryKey(granjaId: string | null | undefined): readonly [string, string] {
  return ['setup-status', granjaId ?? 'none'] as const
}
